import { useState } from 'react'

import { SignInContent } from '@/components/authenticationModal/signInContent'
import { BaseDialogProps } from '@/components/Dialog/DialogContext'
import { LoginRequest } from '@/shared/api/models'
import { usePixieWorldAuthContext } from '@/shared/auth/pixieWorldAuthContext'
import { Dialog, DialogContent, styled } from '@mui/material'

export type AuthDialogProps = BaseDialogProps & {
  onSuccess?: () => void
}

export const AuthDialog: React.FC<AuthDialogProps> = ({ open, onClose, onSuccess }) => {
  const [loginLoading, setLoginLoading] = useState(false)
  const [loginError, setLoginError] = useState('')

  const { signIn } = usePixieWorldAuthContext()

  const handleClose = () => {
    if (onClose) onClose()
    setLoginError('')
    setLoginLoading(false)
  }

  const onSignIn = async (variables: LoginRequest) => {
    setLoginLoading(true)

    try {
      const response = await signIn(variables)

      if (response?.access_token) {
        handleClose()
        if (onSuccess) onSuccess()
      }
    } catch (error) {
      setLoginError('Login Failed')
    } finally {
      setLoginLoading(false)
    }
  }

  return (
    <StyledDialog
      open={open}
      onClose={loginLoading ? undefined : handleClose}
      maxWidth="xs"
      fullWidth
      disableRestoreFocus
    >
      <StyledDialogContent>
        <SignInContent
          errorMessage={loginError}
          loading={loginLoading}
          onClose={handleClose}
          onSignIn={onSignIn}
        />
      </StyledDialogContent>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: ${props => props.theme.typography.pxToRem(12)};
  }
`

const StyledDialogContent = styled(DialogContent)`
  padding: ${props => props.theme.typography.pxToRem(16)};

  &:first-of-type {
    padding-top: ${props => props.theme.typography.pxToRem(16)};
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: ${props => props.theme.typography.pxToRem(24)};

    &:first-of-type {
      padding-top: ${props => props.theme.typography.pxToRem(24)};
    }
  }
`
